import { MappedUploadedPhotos, UploadedPhotoToClassify } from "pages/VehicleAnalysis/types";
import { QuestionKeys, QuestionsKeyMap } from "pages/VehicleCondition/constants";
import { ClassifyQuestion, VehicleConditionQuestions } from "pages/VehicleCondition/types";

import { Photo } from "components/PhotoUpload/types";
import { PointOfImpact } from "components/VehicleImpact/types";

import { DigitalJourney } from "types/DigitalJourneySession";
import { removeNumberSeparators } from "utils/stringHelper";

import { ClientConfig } from "../../app/clientConfig";

export interface BodyParts {
  uploadedPhotos: MappedUploadedPhotos;
  vehicleConditionQuestions: VehicleConditionQuestions;
  pointsOfImpact: PointOfImpact[];
  mileage: string;
  vinInput: string;
  digitalJourney?: DigitalJourney;
}

export const generateClassifyBody = (
  { uploadedPhotos, vehicleConditionQuestions, pointsOfImpact, mileage, vinInput, digitalJourney }: BodyParts,
  config: ClientConfig
) => {
  const {
    vehicleCondition: { disabled: vehicleConditionDisabled, showMileage },
    vin,
  } = config;

  const damagePhotos: UploadedPhotoToClassify[] = [];
  const vehiclePhotos: UploadedPhotoToClassify[] = [];
  const additionalPhotos: UploadedPhotoToClassify[] = [];
  const mileagePhotos: UploadedPhotoToClassify[] = [];

  // Categorising uploaded photos
  Object.values(uploadedPhotos).forEach((photo) => {
    switch (photo.type) {
      case Photo.Damage: {
        const { id, type, ...classifyPhoto } = photo;
        damagePhotos.push(classifyPhoto);
        break;
      }

      case Photo.Vehicle: {
        const { id, type, ...classifyPhoto } = photo;
        vehiclePhotos.push(classifyPhoto);
        break;
      }

      case Photo.Additional: {
        const { id, type, ...classifyPhoto } = photo;
        additionalPhotos.push(classifyPhoto);
        break;
      }

      case Photo.Mileage: {
        const { id, type, ...mileagePhoto } = photo;
        mileagePhotos.push(mileagePhoto);
        break;
      }
    }
  });

  // Fixing vehicle conditions questions
  const vehicleConditions: ClassifyQuestion[] = Object.keys(vehicleConditionQuestions)
    .map((question) => {
      const vehicleQuestion = question as keyof VehicleConditionQuestions;

      const key = QuestionsKeyMap[vehicleQuestion] as QuestionKeys;

      const isDrivableQuestion = key === QuestionKeys.IsDrivable;

      const questionAtomValue = vehicleConditionQuestions[vehicleQuestion];

      const value = isDrivableQuestion && questionAtomValue !== undefined ? !questionAtomValue : questionAtomValue;

      return { key, value };
    })
    .filter((question) => question.value !== undefined) as ClassifyQuestion[];

  return {
    ...(!vehicleConditionDisabled && showMileage && mileage
      ? { mileage: parseInt(removeNumberSeparators(mileage)) }
      : {}),
    vehicleConditions,
    pointsOfImpact,
    damagePhotos,
    vehiclePhotos,
    additionalPhotos,
    mileagePhoto: mileagePhotos[0],
    ...(vin?.showVinInput ? { vin: vinInput } : {}),
    digitalJourney,
  };
};
